<template>
  <v-row justify="center">
    <v-dialog v-model="editVersions" persistent max-width="500px">
      <v-card class="#FFCD" color="#f9f9f9">
        <v-card-title> Edit Version </v-card-title>
        <v-form ref="form" lazy-validation class="mr-6 ml-6 pb-6">
          <v-card class="rounded-larg rounded-lg" elevation="3" tile>
            <v-list-item>
              <v-list-item-content class="pl-3 pr-3">
                <v-row v-if="VersionDetials.publisher[0]['publisherid']">
                  <v-col cols="12" sm="12">
                    <v-autocomplete
                      :rules="[rules.required]"
                      :search-input.sync="publisherNameSearch"
                      v-model="VersionDetials.publisher[0]['publisherid']"
                      class="mx-3"
                      :items="listPublishers"
                      dense
                      label="Publisher Name"
                      outlined
                      item-text="publishername"
                      item-value="publisherid"
                      @keyup="searchPublishers()"
                    ></v-autocomplete>
                    <v-text-field
                      :rules="[rules.required, rules.onlynumber]"
                      v-model="VersionDetials.publisher[0]['publisheryear']"
                      class="mx-3"
                      label="Published Year"
                      outlined
                      dense
                    ></v-text-field>
                    <v-row>
                      <v-col cols="6">
                        <v-switch
                          class="mx-3 pt-0 mt-0"
                          v-model="VersionDetials.status"
                          label="Status"
                          color="primary"
                          hide-details
                        ></v-switch>
                         </v-col>
                        <v-col cols="6">
                        <v-switch
                          class="mx-3 pt-0 mt-0"
                          v-model="VersionDetials.isdefault"
                          label="Is Default"
                          color="primary"
                          hide-details
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" sm="12">
                    <v-skeleton-loader
                      type="table-heading, list-item-two-line"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-card-actions class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close()"
                    >Close</v-btn
                  >
                  <v-btn
                    data-cy="submitBTN"
                    color="blue darken-1"
                    text
                    @click="submit"
                    :loading="loadingEdit"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["editVersions", "ItemEdit"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
      },

      VersionDetials: {
        publisher: [{ publisherid: "" }],
      },
      loadingEdit: false,
      publisherNameSearch: "",
      publisherID: "",
      listPublishers: [],
    };
  },
  created() {
    this.getVersionDetials();
    this.getAllPublishers();
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        let DataForm = {
          Param: {
            status: this.VersionDetials.status ,
            isdefault: this.VersionDetials.isdefault ,
            publisher: {
              publisherid : this.VersionDetials.publisher[0]['publisherid'] ,
              year :  this.VersionDetials.publisher[0]['publisheryear'] ,
            } ,
            
          },
          API: "/admin/book/"+this.$route.params.bookID+"/version/" + this.ItemEdit.versionid
        };
        this.$store
          .dispatch("PutToAPI", DataForm)
          .then(() => {
            this.$store.dispatch("PushSuccessMsg", 'Updated Success');
            this.loadingEdit = false;
            this.$emit("DialogClose", true);
          })
          .catch((error) => {
            this.loadingEdit = false;
             let errorObj = error.data.data;
            this.loadingStepOne = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getVersionDetials() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/book/" +
            this.$route.params.bookID +
            "/version/" +
            this.ItemEdit.versionid
        )
        .then((response) => {
          this.VersionDetials = response.data.data;
        })
        .catch((error) => {
          this.$store.dispatch("PushErrorMsg", error.data.message);
        });
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
        });
    },
    close() {
      this.$emit("DialogClose", false);
    },
  },
};
</script>